<template>
    <v-tabs
        slot="extension"
        color="white"
        slider-color="#e2173d"
        class="list-tabs mb-4"
    >
        <template v-for="(tab, idx) in content">
            <v-tab
                :key="idx"
                class="wrapper-relative"
                :href="'#tab'+idx"
            >
                <v-flex :class="{'px-3': $vuetify.breakpoint.smAndDown, 'px-5': $vuetify.breakpoint.mdAndUp}">{{ tab.title }}</v-flex>
            </v-tab>
            <v-tab-item
                :value="'tab'+idx"
                :key="idx"
                :class="{'pa-3': $vuetify.breakpoint.smAndDown, 'pa-5': $vuetify.breakpoint.mdAndUp}"
            >
                <listText v-if="tab.content.text" :content="tab.content.text" />
                <v-layout v-if="tab.content.links" row wrap
                          class="mt-4"
                >
                    <div v-for="(link, i) in tab.content.links" :key="i">

                        <linkGreen class="mr-5" @click="modal_open_wrapper(link.database_id)">{{ link.title }}</linkGreen>

                    </div>
                </v-layout>
            </v-tab-item>
        </template>
    </v-tabs>
</template>

<script>
import listText   from '@/components/view_blocks/Database/list_blocks/list_text';
import linkGreen from '@/components/ui/links/styled/link_green.vue';
import databaseModal from './../Database_modals/Database_modal';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    listText,
    linkGreen,
    databaseModal,
  },
  props: {
    content: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters('database/modal', [
      'database_detail_modal',
    ]),
  },
  methods: {
    ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_CURRENT',
    ]),
    modal_open_wrapper(database_id) {
      this.OPEN_MODAL(this.database_detail_modal);

      this.SET_CURRENT(database_id);
    },
  },

};
</script>
